var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { cn } from './cn.js';
import { forwardRef } from 'react';
const noStyleButtonClasses = /* cn */ 'bg-none text-inherit border-none p-0 font-inherit leading-inherit';
export const NoStyleButton = styled(forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("button", Object.assign({ ref: ref, className: cn(noStyleButtonClasses, className) }, props)));
})).withConfig({ displayName: "brc-sc-NoStyleButton", componentId: "brc-sc-1q16hd9" }) ``;
//# sourceMappingURL=no-style-button.js.map